<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="formInline.account" placeholder="输入商家地址"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column  align="center" prop="userAddress" label="商家地址" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="copyAddress(scope.row.userAddress)">{{ scope.row.userAddress | plusXing2}}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="telPhone" label="电话" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="copyAddress(scope.row.telPhone)">{{ scope.row.telPhone }}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="shopCard" label="营业执照" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.shopCard != null"
            :src="scope.row.shopCard"
            :preview-src-list="picListCard"
            style="width: 100px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="userCard1" label="身份证正面" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.userCard1 != null"
            :src="scope.row.userCard1"
            :preview-src-list="picList"
            style="width: 100px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="userCard2" label="身份证反面" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.userCard2 != null"
            :src="scope.row.userCard2"
            :preview-src-list="picList2"
            style="width: 100px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="logTime" label="提交时间" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.logTime | timeStamp}}</span>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="status" label="状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div :style="{color: scope.row.status == 1?'green':''}">{{scope.row.status == 0?'待审核':scope.row.status == 1?'审核通过':scope.row.status == 2?'已拒绝':'重复提交'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row.id)">通过</el-button>
            <el-button size="mini" type="danger" @click="deletelClick(scope.row.id)">拒绝</el-button>
          </div>
          <div v-else>
            已处理
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改代理等级" :visible.sync="seleteLevelShow" width="30%" @click='closeDialog()'>
      <el-form label-width="80px">
          <el-form-item label="等级" prop="userLevel">
            <el-input size="small" v-model="infoText" auto-complete="off" placeholder="请输入驳回理由"></el-input>
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="deleteUser">保存</el-button>
      </div>
    </el-dialog>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    
  </div>
</template>

<script>
import { getShopCard, unloadAddGoods, checkShopCard } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        account: ''
      },
      setID: 0,
      infoText: '',
      seleteLevelShow: false,
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      picList: [],
      picListCard: [],
      picList2: [],
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  filters: {
    filterData(val) {
        let newVal = JSON.parse(val);
        return newVal[0]
    },
    plusXing2(str) {
      if (str.length == 0) {
        return "";
      }
      var len = str.length - 4;
      var xing = '';
      for (var i = 0; i < 5; i++) {
        xing += '*';
      }
      return str.substring(0, 6) + xing + str.substring(str.length - 4);
    },
    timeStamp: function(val) {
      let value = val * 1000;
      var date = new Date();
      date.setTime(value);
      var month = date.getMonth() + 1;
      var hours = date.getHours();
      if (hours < 10)
        hours = "0" + hours;
      var minutes = date.getMinutes();
      if (minutes < 10)
        minutes = "0" + minutes;
      var time = month + "-" + date.getDate() +
        " " + hours + ":" + minutes;
      return time;
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    clickType(e) {
      this.formInline.goodType = e;
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      getShopCard(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            this.listData.forEach((item) => {
              this.picList.push(item.userCard1);
              this.picListCard.push(item.shopCard);
              this.picList2.push(item.userCard2);
            });
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.num
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    copyAddress(val) {
      this.$copyText(val.replace(/( |null)/g, '')).then(
        (e) => {
          this.$message.success('复制成功!')
          console.log(e);
        },
        (err) => {
          this.$message.error('复制失败,请重试!')
          console.log(err);
        }
      );
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.$confirm('确定要通过吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.loading = true
            checkShopCard({checkId: row, status:1, info: ''})
              .then(res => {
                this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '审核通过！操作成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('操作失败，请稍后再试！')
              })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      
    },
    deletelClick(val) {
      this.seleteLevelShow = true;
      this.setID = val;
    },
    deleteUser() {
      this.$confirm('确定要驳回吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.loading = true
            checkShopCard({checkId: this.setID,status:2, info: this.infoText})
              .then(res => {
                this.loading = false
                this.seleteLevelShow = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.setID = 0
                  this.info = ''
                  this.$message({
                    type: 'success',
                    message: '审核驳回！操作成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.seleteLevelShow = false
                this.loading = false
                this.$message.error('操作失败，请稍后再试！')
              })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    closeDialog(formName) {
      this.seleteLevelShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/system/userList.vue